import React, { useState } from "react";
import { Box } from "@mui/material";
import { avatarPairFor, initialsOf } from "../../utils/kitPresentation";

// Avatar · Initial (047 kit): initials on a Figma colour pair picked from `colorKey` (the
// uid where there is one, so a person keeps one colour). XL 72, M 40, S 32; `square` is
// the page head's rounded square. Decorative: the name is always written beside it.
const SIZES = {
  72: { fontSize: 28, lineHeight: "36px", letterSpacing: 0, radius: "16px" },
  40: { fontSize: 16, lineHeight: "24px", letterSpacing: 0, radius: "8px" },
  32: { fontSize: 14, lineHeight: "20px", letterSpacing: "0.1px", radius: "4px" },
};

// `src` (057 D17): a profile photo over the initials; if it fails to load the initials stay.
const InitialsAvatar = ({ name, colorKey, src, size = 32, square = false, sx }) => {
  const [broken, setBroken] = useState(false);
  const pair = avatarPairFor(colorKey || name);
  const type = SIZES[size] || SIZES[32];
  return (
    <Box
      aria-hidden
      sx={{
        width: size,
        height: size,
        flexShrink: 0,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        borderRadius: square ? type.radius : "9999px",
        bgcolor: pair.bg,
        color: pair.fg,
        fontSize: type.fontSize,
        lineHeight: type.lineHeight,
        letterSpacing: type.letterSpacing,
        fontWeight: 600,
        userSelect: "none",
        ...sx,
      }}
    >
      {src && !broken ? (
        <Box
          component="img"
          src={src}
          alt=""
          onError={() => setBroken(true)}
          sx={{ width: "100%", height: "100%", objectFit: "cover", borderRadius: "inherit" }}
        />
      ) : (
        initialsOf(name)
      )}
    </Box>
  );
};

export default InitialsAvatar;
